import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// @mui
import { Autocomplete, Popover, Button, Stack, TextField, Container } from '@mui/material';

import { getUsuarios } from './api';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroUsuario = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    fectchUsuarios();
  }, []);
  const fectchUsuarios = async () => {
    const resultado = await getUsuarios();
    setUsuarios(resultado);
  };

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        <Autocomplete
          disablePortal
          disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
          id="usuarioLogado"
          value={filtro.usuarioLogadoAgenda}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, usuarioLogadoAgenda: newValue });
          }}
          options={usuarios}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Usuário" />}
        />

        <Container sx={{ marginTop: 2, width: 300 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroUsuario.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroUsuario;
